/**
 * Hosts the challenge WebView / iframe may load.
 *
 * Each PSP owns its bank/ACS hosts. ThreeDsModal only imports the merged
 * list — adding Stripe is a new export here, not a screen change.
 */
export const WOMPI_CHALLENGE_ORIGINS = [
  'https://*.wompi.sv',
  'https://*.wompi.co',
  'https://*.bancagricola.com',
  'https://*.serfinsa.com',
] as const

export const PAYPAL_CHALLENGE_ORIGINS = [
  'https://*.paypal.com',
  'https://*.paypalobjects.com',
] as const

export const TAGO_CHALLENGE_ORIGINS = [
  'https://*.supabase.co',
  'https://tago.app',
  'https://app.tago.rent',
  'https://api.tago.rent',
  'https://tago.rent',
  'https://www.tago.rent',
  'http://localhost:*',
  'http://127.0.0.1:*',
] as const

export const CHALLENGE_FRAME_ORIGINS: readonly string[] = [
  ...WOMPI_CHALLENGE_ORIGINS,
  ...PAYPAL_CHALLENGE_ORIGINS,
  ...TAGO_CHALLENGE_ORIGINS,
]

function hostFromOriginPattern(origin: string): { suffix?: string; exact?: string } {
  const host = origin
    .replace(/^https?:\/\//, '')
    .split('/')[0]
    ?.replace(/:\*$/, '')
    .replace(/:\d+$/, '')
    .toLowerCase()
  if (!host) return {}
  if (host.startsWith('*.')) return { suffix: host.slice(2) }
  return { exact: host }
}

/** True when the challenge WebView may navigate to this host. */
export function isAllowedChallengeHostname(hostname: string): boolean {
  const host = hostname.toLowerCase()
  return CHALLENGE_FRAME_ORIGINS.some((origin) => {
    const pattern = hostFromOriginPattern(origin)
    if (pattern.suffix) return host === pattern.suffix || host.endsWith(`.${pattern.suffix}`)
    return Boolean(pattern.exact) && host === pattern.exact
  })
}
